import EmblaCarousel from 'embla-carousel';
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures';

class EmblaSlider {
  constructor(rootSelector) {
    const roots = document.querySelectorAll(rootSelector);
    roots.forEach((root) => this.initSlider(root));
  }

  initSlider(root) {
    const viewport = root.querySelector('.embla__viewport');
    const prevBtn = root.querySelector('.prevSlide');
    const nextBtn = root.querySelector('.nextSlide');
    const thumbRoot = root.querySelector('.embla-thumbs-root');
    const thumbViewport = thumbRoot?.querySelector('.embla__viewport');
    const thumbs = thumbRoot?.querySelectorAll('[data-thumb-index]') || [];
    const dotButtons = root.querySelectorAll('.embla-dot');

    if (!viewport) return;

    const embla = EmblaCarousel(viewport, {
      loop: true,
      align: 'start',
      containScroll: 'trimSnaps',
      skipSnaps: true,
    }, [WheelGesturesPlugin()]);

    if (thumbViewport && thumbs.length > 0) {
      const thumbsEmbla = EmblaCarousel(thumbViewport, {
        containScroll: 'trimSnaps',
        dragFree: true,
        slidesToScroll: 1,
      });

      // Optional: sync thumb scrolling with selected main slide
      embla.on('select', () => {
        thumbsEmbla.scrollTo(embla.selectedScrollSnap());
      });

      // Function to update last visible thumbnail fade
      const updatePartiallyVisibleThumbs = () => {
        // Remove fade from all thumbnails first
        thumbs.forEach((thumb) => thumb.classList.remove('more-slides'));

        const viewportRect = thumbViewport.getBoundingClientRect();

        thumbs.forEach((thumb) => {
          const thumbRect = thumb.getBoundingClientRect();

          // Check if the thumbnail is partially outside the viewport
          const isPartiallyHidden =
            thumbRect.left < viewportRect.left - 5 || thumbRect.right > viewportRect.right + 5;

          if (isPartiallyHidden) {
            thumb.classList.add('more-slides');
          }
        });
      };

      // Initial highlight and last visible thumbnail
      thumbsEmbla.on('scroll', updatePartiallyVisibleThumbs);
      thumbsEmbla.on('resize', updatePartiallyVisibleThumbs);
      updatePartiallyVisibleThumbs();
    }

    // ✅ Attach thumbnails logic
    if (thumbs.length > 0) {
      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => embla.scrollTo(index));
      });

      embla.on('select', () => {
        const selectedIndex = embla.selectedScrollSnap();
        thumbs.forEach((thumb, idx) => {
          thumb.classList.toggle('opacity-80', idx === selectedIndex);
        });
      });

      // Trigger initial highlight
      embla.emit('select');
    }

    if (dotButtons.length > 0) {
      dotButtons.forEach((dot, index) => {
        dot.addEventListener('click', () => embla.scrollTo(index));
      });

      embla.on('select', () => {
        const selectedIndex = embla.selectedScrollSnap();
        dotButtons.forEach((dot, idx) => {
          dot.classList.toggle('is-selected', idx === selectedIndex);
        });
      });

      // Initial state
      embla.emit('select');
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => embla.scrollPrev());
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => embla.scrollNext());
    }
  }
}

// Initialize all sliders when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new EmblaSlider('.embla-root');
});